/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* SM Beauty product accumulated price -------------------------------------- */
(function () {
  'use strict';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'number' ? precision : 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (number === null || isNaN(number)) {
      return '0';
    }

    var fixed = (number / 100).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var value = '';

    switch (match ? match[1] : 'amount') {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 0, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getProductSection(element) {
    return element && element.closest ? element.closest('[data-section-type="product"]') : null;
  }

  function getQuantity(section) {
    var input = section.querySelector('.quantity-selector--product [name="quantity"], form[action*="/cart/add"] [name="quantity"]');
    var quantity = input ? parseInt(input.value, 10) : 1;

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function updateAccumulatedPrice(section, variant) {
    if (!section) {
      return;
    }

    var quantity = getQuantity(section);
    var totalElements = section.querySelectorAll('[data-sm-order-total]');

    Array.prototype.forEach.call(totalElements, function (totalElement) {
      if (variant && typeof variant.price !== 'undefined') {
        totalElement.setAttribute('data-unit-price', variant.price);
      }

      var unitPrice = parseInt(totalElement.getAttribute('data-unit-price'), 10);
      var output = totalElement.querySelector('[data-sm-order-total-value]');

      if (!output || !Number.isFinite(unitPrice)) {
        return;
      }

      output.textContent = formatMoney(
        unitPrice * quantity,
        totalElement.getAttribute('data-money-format')
      );
    });
  }

  function updateAllAccumulatedPrices() {
    var sections = document.querySelectorAll('[data-section-type="product"]');

    Array.prototype.forEach.call(sections, function (section) {
      updateAccumulatedPrice(section);
    });
  }

  document.addEventListener('variant:changed', function (event) {
    updateAccumulatedPrice(
      getProductSection(event.target),
      event.detail && event.detail.variant ? event.detail.variant : null
    );
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(
      '.quantity-selector--product [data-action="increase-picker-quantity"], ' +
      '.quantity-selector--product [data-action="decrease-picker-quantity"]'
    );

    if (!button) {
      return;
    }

    var section = getProductSection(button);

    window.requestAnimationFrame(function () {
      updateAccumulatedPrice(section);
    });
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches || !event.target.matches('.quantity-selector--product [name="quantity"]')) {
      return;
    }

    updateAccumulatedPrice(getProductSection(event.target));
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('.quantity-selector--product [name="quantity"]')) {
      return;
    }

    updateAccumulatedPrice(getProductSection(event.target));
  });

  document.addEventListener('focusout', function (event) {
    if (!event.target.matches || !event.target.matches('.quantity-selector--product [name="quantity"]')) {
      return;
    }

    window.requestAnimationFrame(function () {
      updateAccumulatedPrice(getProductSection(event.target));
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllAccumulatedPrices);
  } else {
    updateAllAccumulatedPrices();
  }
})();

/* SM Beauty collection/search card quantity controls ----------------------- */
(function () {
  'use strict';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'number' ? precision : 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (number === null || isNaN(number)) {
      return '0';
    }

    var fixed = (number / 100).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var value = '';

    switch (match ? match[1] : 'amount') {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 0, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getMoq(input) {
    return Math.max(1, parseInt(input.getAttribute('data-moq') || input.getAttribute('step'), 10) || 1);
  }

  function normalizeUp(value, moq) {
    var parsedValue = parseInt(value, 10);

    if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
      return moq;
    }

    return Math.max(moq, Math.ceil(parsedValue / moq) * moq);
  }

  function getVariantData(controls) {
    var select = controls.querySelector('[data-sm-card-variant-select]');
    var source = select ? select.options[select.selectedIndex] : controls;

    return {
      price: parseInt(source.getAttribute('data-price') || controls.getAttribute('data-price'), 10) || 0,
      compareAtPrice: parseInt(source.getAttribute('data-compare-at-price') || controls.getAttribute('data-compare-at-price'), 10) || 0,
      moq: Math.max(1, parseInt(source.getAttribute('data-moq') || controls.getAttribute('data-moq'), 10) || 1),
      hasMoq: (source.getAttribute('data-has-moq') || controls.getAttribute('data-has-moq')) === 'true',
      available: (source.getAttribute('data-available') || controls.getAttribute('data-available')) !== 'false'
    };
  }

  function renderPrice(priceList, data, moneyFormat) {
    if (!priceList || !data.price) {
      return;
    }

    priceList.innerHTML = '';

    var currentPrice = document.createElement('span');
    currentPrice.className = data.compareAtPrice > data.price ? 'price price--highlight' : 'price';
    currentPrice.textContent = formatMoney(data.price, moneyFormat);
    priceList.appendChild(currentPrice);

    if (data.compareAtPrice > data.price) {
      var comparePrice = document.createElement('span');
      comparePrice.className = 'price price--compare';
      comparePrice.textContent = formatMoney(data.compareAtPrice, moneyFormat);
      priceList.appendChild(comparePrice);
    }
  }

  function updateCard(controls, resetQuantity) {
    if (!controls) {
      return;
    }

    var card = controls.closest('.product-item');
    var input = controls.querySelector('[name="quantity"]');
    var quantitySelector = controls.querySelector('[data-sm-card-quantity]');
    var addButton = controls.querySelector('[data-action="add-to-cart"]');
    var totalValue = controls.querySelector('[data-sm-card-total-value]');
    var moneyFormat = controls.getAttribute('data-money-format');
    var variantData = getVariantData(controls);

    controls.setAttribute('data-moq', variantData.moq);

    if (quantitySelector) {
      quantitySelector.setAttribute('data-moq', variantData.moq);
    }

    if (input) {
      input.setAttribute('data-moq', variantData.moq);
      input.setAttribute('min', variantData.moq);
      input.setAttribute('step', variantData.moq);

      if (resetQuantity || !input.value) {
        input.value = variantData.moq;
      } else {
        input.value = normalizeUp(input.value, variantData.moq);
      }
    }

    if (totalValue && input) {
      var quantity = normalizeUp(input.value, variantData.moq);
      totalValue.textContent = formatMoney(variantData.price * quantity, moneyFormat);
    }

    if (addButton) {
      addButton.disabled = !variantData.available;
      addButton.classList.toggle('button--disabled', !variantData.available);
      addButton.classList.toggle('button--primary', variantData.available);
    }

    if (card) {
      renderPrice(
        card.querySelector('[data-sm-card-price-list]'),
        variantData,
        moneyFormat
      );

      var moqLabel = card.querySelector('[data-sm-card-moq-label]');
      if (moqLabel) {
        moqLabel.hidden = !variantData.hasMoq;
        var moqValue = moqLabel.querySelector('[data-sm-card-moq-value]');
        if (moqValue) {
          moqValue.textContent = variantData.moq;
        }
      }
    }
  }

  function initializeCard(controls) {
    if (!controls || controls.getAttribute('data-sm-card-initialized') === 'true') {
      return;
    }

    controls.setAttribute('data-sm-card-initialized', 'true');
    updateCard(controls, true);
  }

  function initializeCards(root) {
    if (!root || root.nodeType !== 1 && root.nodeType !== 9) {
      return;
    }

    if (root.matches && root.matches('[data-sm-card-purchase]')) {
      initializeCard(root);
    }

    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-sm-card-purchase]'), initializeCard);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-sm-card-quantity-action]');

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var controls = button.closest('[data-sm-card-purchase]');
    var input = controls && controls.querySelector('[name="quantity"]');

    if (!input) {
      return;
    }

    var moq = getMoq(input);
    var currentValue = parseInt(input.value, 10) || moq;

    if (button.getAttribute('data-sm-card-quantity-action') === 'increase') {
      input.value = currentValue < moq ? moq : currentValue % moq === 0 ? currentValue + moq : normalizeUp(currentValue, moq);
    } else {
      input.value = currentValue <= moq ? moq : Math.max(moq, Math.floor((currentValue - 1) / moq) * moq);
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('[data-sm-card-variant-select]')) {
      updateCard(event.target.closest('[data-sm-card-purchase]'), true);
      return;
    }

    if (event.target.matches && event.target.matches('.sm-card-quantity-selector__value')) {
      var moq = getMoq(event.target);
      event.target.value = normalizeUp(event.target.value, moq);
      updateCard(event.target.closest('[data-sm-card-purchase]'), false);
    }
  });

  document.addEventListener('focusout', function (event) {
    if (!event.target.matches || !event.target.matches('.sm-card-quantity-selector__value')) {
      return;
    }

    var moq = getMoq(event.target);
    event.target.value = normalizeUp(event.target.value, moq);
    updateCard(event.target.closest('[data-sm-card-purchase]'), false);
  });

  document.addEventListener('product:added', function (event) {
    var button = event.detail && event.detail.button;
    var controls = button && button.closest ? button.closest('[data-sm-card-purchase]') : null;

    if (controls) {
      updateCard(controls, true);
    }
  });

  function start() {
    initializeCards(document);

    if (!window.MutationObserver || !document.body) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          initializeCards(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* SM Beauty desktop dropdown trigger alignment ----------------------------- */
(function () {
  'use strict';

  var PANEL_SELECTOR =
    '.nav-bar__item--static > .nav-dropdown.adaptive-header-menu, ' +
    '.nav-bar__item--static > .nav-dropdown.kbeauty-split-menu';
  var DESKTOP_BREAKPOINT = 1451;
  var VIEWPORT_GUTTER = 20;
  var resizeTimer = null;

  function getDirectTrigger(navItem) {
    if (!navItem) {
      return null;
    }

    for (var i = 0; i < navItem.children.length; i += 1) {
      var child = navItem.children[i];

      if (
        child.classList &&
        child.classList.contains('nav-bar__link') &&
        child.getAttribute('aria-haspopup') === 'true'
      ) {
        return child;
      }
    }

    return null;
  }

  function positionPanel(panel) {
    if (!panel) {
      return;
    }

    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      panel.style.removeProperty('--sm-menu-left');
      return;
    }

    var navItem = panel.parentElement;
    var navBar = panel.closest('.nav-bar');
    var trigger = getDirectTrigger(navItem);

    if (!navBar || !trigger) {
      return;
    }

    var navBarRect = navBar.getBoundingClientRect();
    var triggerRect = trigger.getBoundingClientRect();
    var panelWidth = panel.getBoundingClientRect().width || panel.offsetWidth;

    if (!panelWidth) {
      return;
    }

    var idealLeft =
      triggerRect.left +
      triggerRect.width / 2 -
      navBarRect.left -
      panelWidth / 2;

    var maximumLeft = Math.max(
      VIEWPORT_GUTTER,
      navBarRect.width - panelWidth - VIEWPORT_GUTTER
    );

    var clampedLeft = Math.min(
      Math.max(idealLeft, VIEWPORT_GUTTER),
      maximumLeft
    );

    panel.style.setProperty('--sm-menu-left', Math.round(clampedLeft) + 'px');
  }

  function positionAllPanels() {
    var panels = document.querySelectorAll(PANEL_SELECTOR);

    Array.prototype.forEach.call(panels, positionPanel);
  }

  function getDirectPanel(navItem) {
    if (!navItem) {
      return null;
    }

    for (var i = 0; i < navItem.children.length; i += 1) {
      var child = navItem.children[i];

      if (
        child.classList &&
        child.classList.contains('nav-dropdown') &&
        (
          child.classList.contains('adaptive-header-menu') ||
          child.classList.contains('kbeauty-split-menu')
        )
      ) {
        return child;
      }
    }

    return null;
  }

  function positionPanelForTrigger(trigger) {
    if (!trigger || !trigger.parentElement) {
      return;
    }

    var panel = getDirectPanel(trigger.parentElement);

    if (panel) {
      window.requestAnimationFrame(function () {
        positionPanel(panel);
      });
    }
  }

  function handleTriggerEvent(event) {
    var trigger = event.target.closest && event.target.closest(
      '.nav-bar__item--static > .nav-bar__link[aria-haspopup="true"]'
    );

    if (trigger) {
      positionPanelForTrigger(trigger);
    }
  }

  function start() {
    positionAllPanels();

    document.addEventListener('mouseover', handleTriggerEvent, true);
    document.addEventListener('focusin', handleTriggerEvent, true);
    document.addEventListener('click', handleTriggerEvent, true);

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(positionAllPanels, 80);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* SM Beauty desktop navigation open-state ---------------------------------
   Mirrors the nav dropdown aria-hidden state onto <html>. This lets CSS
   suppress homepage promo arrows and raise the complete header stacking
   context while K-Beauty, Shop by Brand, or another desktop menu is open. */
(function () {
  'use strict';

  function syncDesktopMenuState() {
    var desktopMenuOpen = window.matchMedia('(min-width: 1000px)').matches &&
      !!document.querySelector('.nav-bar .nav-dropdown[aria-hidden="false"], .nav-bar .mega-menu[aria-hidden="false"]');

    document.documentElement.classList.toggle('sm-desktop-menu-open', desktopMenuOpen);
  }

  function initializeDesktopMenuState() {
    var navBar = document.querySelector('.nav-bar');

    if (!navBar) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      for (var index = 0; index < mutations.length; index += 1) {
        if (mutations[index].attributeName === 'aria-hidden') {
          window.requestAnimationFrame(syncDesktopMenuState);
          break;
        }
      }
    });

    observer.observe(navBar, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true
    });

    navBar.addEventListener('mouseenter', function () {
      window.requestAnimationFrame(syncDesktopMenuState);
    }, true);

    navBar.addEventListener('mouseleave', function () {
      window.requestAnimationFrame(syncDesktopMenuState);
    }, true);

    document.addEventListener('click', function () {
      window.requestAnimationFrame(syncDesktopMenuState);
    });

    window.addEventListener('resize', syncDesktopMenuState);
    syncDesktopMenuState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDesktopMenuState);
  } else {
    initializeDesktopMenuState();
  }
})();
